// Japanese locale for EmbedPDF viewer
export const jaJP = {
    code: 'ja',
    name: '日本語',
    translations: {
        document: {
            loading: '読み込み中...',
            error: 'ドキュメントの読み込みエラー',
            noPages: 'ページがありません'
        },
        documentError: {
            title: 'ドキュメントエラー',
            errorCode: 'エラーコード',
            close: '閉じる',
            retry: '再試行',
            description: 'ドキュメントを読み込めませんでした'
        },
        mode: {
            view: '表示',
            annotate: '注釈',
            shapes: '図形',
            redact: '墨消し',
            fillAndSign: '入力と署名',
            form: 'フォーム'
        },
        commands: {
            zoom: {
                in: '拡大',
                out: '縮小',
                fitWidth: '幅に合わせる',
                fitPage: 'ページに合わせる',
                automatic: '自動',
                level: 'ズームレベル ({level}%)',
                inArea: '選択範囲を拡大'
            },
            fullscreen: {
                enter: '全画面表示',
                exit: '全画面を終了'
            },
            rotate: {
                clockwise: '右に回転',
                counterclockwise: '左に回転'
            },
            menu: 'メニュー',
            sidebar: 'サイドバー',
            search: '検索',
            comment: 'コメント',
            download: 'ダウンロード',
            print: '印刷',
            openFile: 'PDFを開く',
            save: '保存',
            settings: '設定',
            view: '表示',
            annotate: '注釈',
            shapes: '図形',
            redact: '墨消し',
            fillAndSign: '入力と署名',
            form: 'フォーム',
            pan: 'パン',
            pointer: 'ポインター',
            undo: '元に戻す',
            redo: 'やり直す',
            copy: 'コピー',
            screenshot: 'スクリーンショット',
            nextPage: '次のページ',
            previousPage: '前のページ'
        },
        toolbar: {
            mode: 'モード'
        },
        selection: {
            copy: 'コピー',
            highlight: 'ハイライト'
        },
        annotation: {
            highlight: 'ハイライト',
            underline: '下線',
            strikethrough: '取り消し線',
            comment: 'コメント',
            freeText: 'テキスト',
            drawing: '描画'
        },
        page: {
            of: '/',
            pageNumber: 'ページ {current} / {total}'
        }
    }
};
